import Vue from 'vue'
import store from '@/store/store'
import Router from 'vue-router'
import Frontpage from '@/components/Frontpage'
import Dashboard from '@/components/Dashboard'
import Welcome from '@/components/homepage/Welcome'
import Register from '@/components/homepage/Register'
import Login from '@/components/homepage/Login'
import Content from '@/components/dashboard/Content'
import Pendingapplications from '@/components/dashboard/Pendingapplications'
import Submittedapplications from '@/components/dashboard/Submittedapplications'
// import Verifiedapplications from '@/components/dashboard/Verifiedapplications'
import Approvedapplications from '@/components/dashboard/Approvedapplications'
import Rejectedapplications from '@/components/dashboard/Rejectedapplications'
import Cancelledapplications from '@/components/dashboard/Cancelledapplications'

Vue.use(store)
Vue.use(Router)

export default new Router({
  routes: [
    {
      // Set default route to submit new applications
      path: '/dashboard',
      redirect: '/submittedapplications'
    },
    {
      path: '/',
      name: 'home',
      component: Welcome,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.userdata.accesstoken) {
          next('dashboard')
        } else {
          next()
        }
      }
    },
    {
      path: '/frontpage',
      name: 'frontpage',
      component: Frontpage,
      children: [
        { path: '/welcome',
          name: 'welcome',
          component: Welcome,
          beforeEnter: (to, from, next) => {
            if (store.state.auth.userdata.accesstoken) {
              next('dashboard')
            } else {
              next()
            }
          }
        },
        { path: '/register',
          name: 'register',
          component: Register,
          beforeEnter: (to, from, next) => {
            if (store.state.auth.userdata.accesstoken) {
              next('dashboard')
            } else {
              next()
            }
          }
        },
        { path: '/login',
          name: 'login',
          component: Login,
          beforeEnter: (to, from, next) => {
            if (store.state.auth.userdata.accesstoken) {
              next('dashboard')
            } else {
              next()
            }
          }
        }
      ]
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      beforeEnter: (to, from, next) => {
        store.dispatch('tryAutoLogin')
        console.log(store.state.auth.userdata.accesstoken)
        if (!store.state.auth.userdata.accesstoken) {
          next('welcome')
        } else {
          next()
        }
      },
      children: [
        { path: '/content',
          name: 'content',
          component: Content,
          beforeEnter: (to, from, next) => {
            if (!store.state.auth.userdata.accesstoken) {
              next('welcome')
            } else {
              next()
            }
          }
        },
        { path: '/submittedapplications',
          name: 'submittedapplications',
          component: Submittedapplications,
          beforeEnter: (to, from, next) => {
            if (!store.state.auth.userdata.accesstoken) {
              next('welcome')
            } else {
              console.log('in submit new application')
              store.commit('setApplicationactivepage', 'submittedapplications')
              next()
            }
          }
        },
        { path: '/pendingapplications',
          name: 'pendingapplications',
          component: Pendingapplications,
          beforeEnter: (to, from, next) => {
            if (!store.state.auth.userdata.accesstoken) {
              next('welcome')
            } else {
              console.log('in pending new application')
              store.commit('setApplicationactivepage', 'pendingapplications')
              next()
            }
          }
        },
        { path: '/approvedapplications',
          name: 'approvedapplications',
          component: Approvedapplications,
          beforeEnter: (to, from, next) => {
            if (!store.state.auth.userdata.accesstoken) {
              next('welcome')
            } else {
              console.log('in approved applications')
              store.commit('setApplicationactivepage', 'approvedapplications')
              next()
            }
          }
        },
        { path: '/rejectedapplications',
          name: 'rejectedapplications',
          component: Rejectedapplications,
          beforeEnter: (to, from, next) => {
            if (!store.state.auth.userdata.accesstoken) {
              next('welcome')
            } else {
              console.log('in rejected applications')
              store.commit('setApplicationactivepage', 'rejectedapplications')
              next()
            }
          }
        },
        { path: '/cancelledapplications',
          name: 'cancelledapplications',
          component: Cancelledapplications,
          beforeEnter: (to, from, next) => {
            if (!store.state.auth.userdata.accesstoken) {
              next('welcome')
            } else {
              console.log('in cancelled applications')
              store.commit('setApplicationactivepage', 'cancelledapplications')
              next()
            }
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js